<!-- prettier-ignore -->

<div class="chat__form-wrapper">
  <!-- <div class="opacityEffect opacityEffectStart"></div>
  <div class="opacityEffect opacityEffectEnd"></div> -->

  <form #form [formGroup]="chatForm" class="chat__form" (ngSubmit)="handleSubmit()">
    @if(!isRecording() || isStreaming()){
      <chat-input [chatForm]="chatForm" class="chat__chat-input-wrapper" (keydownEvent)="onEnterKey($event)" />
    }
    <canvas #waveformCanvas [width]="getCanvasWidth(form)" style="margin: 0 auto;" height="30" [ngClass]="{'d-none': !isRecording() || isStreaming()}"></canvas>


    @if(isStreaming()){
      <cancel-button (click)="handleStreamingStop()" [chatForm]="chatForm" />
    }
    @else if(!isStreaming() && !showRecordIcon() && isRecording()){
      <cancel-button (click)="handleRecordingStop()" [chatForm]="chatForm" />
    }
    @else if(!isStreaming() && !isRecording() && dataChat.inputText() || typeChat() === 'text'){
      <send-button [chatForm]="chatForm" />
    }
    @else {
      <voice-button 
        [chatForm]="chatForm" 
        (actionEmitter)="handleReceivedData($event)"
      />
    }
  </form>

  <div class="chat__footer">

    <div class="chat__footer__info">
      <icon-info></icon-info>
      <span (click)="openModal()" class="chat__footer__info__disclaimer">{{ 'Considera verificar la información.' | translate }} <b>{{ 'Más información.' | translate }}</b></span>
    </div>

    <div (click)="goToiUrban()" class="chat__footer__powered">
      <span class="powered-by">Powered by</span>
      <span class="brand">iURBAN</span>
      <icon-link></icon-link>
    </div>

</div>
